import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';
import variables from '../../variables.module.scss';

const CustomSlider = withStyles({
  root: {
    color: variables.primary,
    height: 5,
  },
  thumb: {
    height: 32,
    width: 32,
    marginTop: -13,
    marginLeft: -15,
    paddingTop: 2,
    backgroundColor: 'inherit',
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  track: {
    height: 5,
    borderRadius: 4,
    backgroundColor: variables.stepWizardSliderTrackColor,
  },
  rail: {
    height: 5,
    borderRadius: 4,
  },
})(Slider);

export default CustomSlider;
